module.exports = __webpack_public_path__ + "img/delete.7a2c3b91.svg";